/** @format */

const restrictedEmails = [
  'autoricambi.cagliari@gmail.com',
  'venditeautodemolizioni@gmail.com',
  'vendite.autodemolizioni@gmail.com',
];

const normalizeEmail = email => {
  if (!email) {
    return '';
  }
  const trimmed = String(email).trim().toLowerCase();
  const parts = trimmed.split('@');
  if (parts.length !== 2) {
    return trimmed;
  }
  const [local, domain] = parts;
  if (domain === 'gmail.com') {
    return `${local.replace(/\./g, '')}@${domain}`;
  }
  return trimmed;
};

const normalizedRestrictedEmails = new Set(
  restrictedEmails.map(email => normalizeEmail(email)),
);

export const isRestrictedUser = email =>
  normalizedRestrictedEmails.has(normalizeEmail(email));

export default isRestrictedUser;
